import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in! Travel inspiration coming your way.");
      setEmail("");
    } catch {
      toast.error("Could not subscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-lg" data-testid="newsletter-form">
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com" data-testid="newsletter-email-input"
        className="flex-1 bg-bone/10 border border-bone/20 rounded-full px-6 py-3.5 text-bone placeholder:text-bone/40 focus:outline-none focus:border-sun transition-colors" />
      <button type="submit" disabled={loading} data-testid="newsletter-submit-btn"
        className="inline-flex items-center justify-center gap-2 bg-sun text-bone font-semibold px-8 py-3.5 rounded-full hover:bg-[#e85a28] hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-60">
        {loading ? "Joining..." : <><Send size={15} /> Subscribe</>}
      </button>
    </form>
  );
};
